// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__m_KXx","resendInfoText":"OnGoingPaymentBox_resendInfoText__2y6U0"};